module.exports = __webpack_public_path__ + "img/login-background.35332a77.png";